export default "<p>validacion-empresas works!</p>\n"